import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { t as translations } from "../i18n/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    return localStorage.getItem("oasis_lang") || "fr";
  });

  useEffect(() => {
    localStorage.setItem("oasis_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const tr = translations[lang] || translations.fr;

  const tx = useCallback(
    (multi) => {
      if (!multi) return "";
      if (typeof multi === "string") return multi;
      return multi[lang] || multi.fr || "";
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: tr, tx }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
